/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import ReactDOM from "react-dom";

// material react table
import { MaterialReactTable } from "material-react-table";
import * as XLSX from "xlsx";

//import translation function for language translation
import { useTranslation } from "react-i18next";
import useMRTLocalization from "hooks/useMRTLocalization";

//import api requiremnts
import * as url from "urlhelpers/UrlHelper";
import { getData } from "utils/Gateway";

import { Link } from "react-router-dom";

//import context
import { GlobalProvider } from "context/GlobalContext";
import QuestionHeader from "./Header/QuestionHeader";

const QuestionListArea = () => {
  const {
    setEditQuestionData,
    reloadQuestionList,
    setReloadQuestionList,
    screenHeight,
  } = useContext(GlobalProvider);

  const { t } = useTranslation(); //for translation
  const mrtLocalization = useMRTLocalization();
  const token = localStorage.getItem("token");
  // without pagination ------------------------------------
  const [questions, setQuestions] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const [rowSelection, setRowSelection] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  /* useState hook to download excel file */
  const [downloadExcel, setDownloadExcel] = useState(false);
  /* hook to get number of records */
  const [records, setRecords] = useState(0);

  const blockRefSelected = useRef(null);

  const updateSelectedCount = (selectCount) => {
    const blockElementSelect = ReactDOM.findDOMNode(blockRefSelected.current);
    if (blockElementSelect) {
      blockElementSelect.innerHTML = selectCount;
    }
  };

  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    return questions.filter((item) => selectedIds.includes(item._id));
  };

  /* Excel export */
  const exportExcel = () => {
    const selectedData = getSelectedData();
    const exportData = selectedData.length > 0 ? selectedData : questions;
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Questions.xlsx");
  };

  /* custom name html */
  const nameHTML = ({ dataItem }) => {
    return (
      <div className="kendoCustomColumn overflow-visible">
        <div className="d-flex align-items-center gap-2">
          <p className="d-flex gap-2 align-items-center">
            <span className="d-block">{dataItem.name}</span>
          </p>

          <Link
            className="ml-auto edit_icon"
            type="button"
            to="#saveUpdateQuestionPopup"
            data-bs-toggle="offcanvas"
            aria-expanded="false"
          >
            <span
              className="d-block material-symbols-outlined icon-md"
              onClick={() => {
                setEditQuestionData(dataItem);
              }}
            >
              edit
            </span>
          </Link>
        </div>
      </div>
    );
  };

  //function for get all question
  const getAllQuestion = async () => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASEURL + url.API_GET_ALL_QUESTION + `?token=${token}`;

      console.log("question list url =====>>>", requestUrl);

      const response = await getData(requestUrl);

      console.log("question list response ========>>>", response);

      if (response.data) {
        setQuestions(response.data);
        setResponseReceived(true);
        setRecords(response.data.length);
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  /* hook to hit exportExcel() function*/
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  useEffect(() => {
    if (responseReceived === false) {
      getAllQuestion();
    }
  }, [responseReceived]);

  useEffect(() => {
    if (reloadQuestionList) {
      getAllQuestion();
      setReloadQuestionList(false);
    }
  }, [reloadQuestionList]);

  /* set records when questions changes */
  useEffect(() => {
    setRecords(questions.length);
  }, [questions]);

  /* sync selected count to DOM ref */
  useEffect(() => {
    const selectedCount = Object.keys(rowSelection).filter((key) => rowSelection[key]).length;
    updateSelectedCount(selectedCount);
  }, [rowSelection, questions]);

  const tableColumns = useMemo(
    () => [
      {
        id: "name",
        accessorKey: "name",
        header: t("Question"),
        Cell: ({ row }) => nameHTML({ dataItem: row.original }),
        filterFn: "includesString",
        size: 300,
        muiTableBodyCellProps: {
          sx: { overflow: "visible", position: "static" },
        },
      },
      {
        id: "questiontype.slug",
        accessorFn: (row) => row.questiontype?.slug ?? "",
        header: t("Type"),
        size: 200,
      },
      {
        id: "code",
        accessorKey: "code",
        header: t("Code"),
        size: 200,
      },
      {
        id: "questiondate",
        accessorKey: "questiondate",
        header: t("Question Date"),
        size: 200,
      },
    ],
    [questions]
  );

  return (
    <div className="tab-content" id="surveyTabContent">
      <div className="container-fluid px-4">
        <QuestionHeader
          setDownloadExcel={setDownloadExcel}
          records={records}
          blockRefSelected={blockRefSelected}
        />

        <div className="table-responsive">
          {/* ========= material react table start ======= */}
          <MaterialReactTable
            localization={mrtLocalization}
            columns={tableColumns}
            data={questions}
            globalFilterFn="includesString"
            enableSorting
            enableFilters
            enableGlobalFilter
            enableColumnFilterModes={false}
            muiTableHeadCellProps={{ title: "" }}
            enableGrouping
            enableColumnOrdering
            enableStickyHeader
            enableRowSelection
            onRowSelectionChange={setRowSelection}
            getRowId={(row) => row._id}
            state={{ rowSelection, isLoading }}
            renderLoadingOverlay={() => null}
            muiLinearProgressProps={{ sx: { display: "none" } }}
            muiCircularProgressProps={{ sx: { display: "none" } }}
            muiTableContainerProps={{ sx: { maxHeight: screenHeight - 50 } }}
            muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
            muiTableBodyProps={{ sx: { overflow: "visible" } }}
            initialState={{
              pagination: { pageSize: 100, pageIndex: 0 },
              showColumnFilters: true,
            }}
          />
          {/* ========= material react table end ======= */}
        </div>
      </div>
    </div>
  );
};

export default QuestionListArea;
